<div
  dgxUploader
  (fileDropped)="onImageSelected($event)"
  (dragState)="onChangeDragState($event)"
  [ngClass]="{
    'image-upload-container--focused': uploaderFocused
  }"
  class="image-upload-container image-upload-container--{{ templateOption }}"
>
  <label class="image-upload" [attr.aria-label]="i18n.dgImageEdit_ChangePhoto">
    <div
      class="image-upload-wrap"
      [ngClass]="{ 'profile-pic border': templateOption === 'profile-pic' }"
    >
      <!-- Optional: the region the original image preview will show up if provided  -->
      <ng-content select=".original-preview-image-parent"></ng-content>

      <!-- placeholder -->
      <div
        *ngIf="showPlaceholder && !isUploading"
        class="image-uploader-placeholder"
      >
        <div class="vertical-center">
          <span class="bg-color-ebony-a61 round guts-p-full-half ib">
            <df-icon
              icon="image-plus"
              size="medium"
              class="color-white"
            ></df-icon>
          </span>
        </div>
      </div>

      <df-spinner [isSpinning]="isUploading"></df-spinner>
    </div>

    <input
      type="file"
      #inputRef
      data-dgat="image-uploader-148"
      class="image-upload-input"
      (change)="onImageSelected($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />
  </label>
</div>
